import type { SVGProps } from "react";
export interface Dice4IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Dice4Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Dice4IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 12A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
      <path
        fill={color}
        d="M16 16.129a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm1 .741a.6.6 0 0 0 .112-.245l.013-.125-.013-.127A.6.6 0 0 0 17 16.13zm-8.888-.497A.6.6 0 0 0 8 16.13v.741a.6.6 0 0 0 .112-.245l.013-.125zM7 16.13a.62.62 0 0 0-.125.37l.012.127c.019.09.06.172.113.244zm9-9a.62.62 0 0 0-.124.37l.011.126c.019.091.06.173.113.245zm1 .741a.6.6 0 0 0 .112-.245l.013-.125-.013-.126A.6.6 0 0 0 17 7.129v.741Zm-8.888-.496A.6.6 0 0 0 8 7.129v.741a.6.6 0 0 0 .112-.245l.013-.125-.013-.126ZM7 7.129a.62.62 0 0 0-.125.37l.012.126A.6.6 0 0 0 7 7.87v-.74Zm2.125 9.37a1.625 1.625 0 0 1-3.242.167l-.008-.166.009-.166A1.625 1.625 0 0 1 7.5 14.875l.167.009A1.624 1.624 0 0 1 9.125 16.5Zm9 0a1.625 1.625 0 0 1-3.242.167l-.008-.166.009-.166a1.625 1.625 0 0 1 1.616-1.459l.166.009c.82.083 1.46.774 1.46 1.616Zm-9-9a1.625 1.625 0 0 1-3.242.167L5.876 7.5l.009-.166A1.625 1.625 0 0 1 7.5 5.875l.167.009A1.624 1.624 0 0 1 9.125 7.5Zm9 0a1.625 1.625 0 0 1-3.242.167l-.008-.166.009-.166A1.625 1.625 0 0 1 16.5 5.875l.166.009c.82.083 1.46.774 1.46 1.616Z"
      />
    </svg>
  );
}
